// The pipeline: leads, their stages, the importer, and the urgency vocabulary the lead
// rows are sorted and filtered by.
//
// Pure data — no imports, ever. errors.js reads he.leads.needContact at module scope,
// so a part reaching back for it would hand that read a half-built object. See he.js.
const leads = {
  leads: {
    title: 'לידים',
    newLead: 'ליד חדש',
    editLead: 'עריכת ליד',
    // Filter is by lead ownership, not tasks (this is the pipeline, not the board).
    allLeads: 'כל הלידים',
    mineLeads: 'הלידים שלי',
    emptyGroupTasks: 'אין משימות לליד זה.',
    noNextStep: 'אין צעד הבא',
    // כותרת עמודת המיון. המיון לפי תאריך היעד של הצעד הבא — מי דורש מעקב קודם.
    nextStep: 'צעד הבא',
    noneMatch: 'אין לידים שתואמים לסינון.',
    noContact: 'ללא איש קשר',
    owner: 'בעלים',
    source: 'מקור',
    noSource: 'ללא מקור',
    referredBy: 'הופנה על ידי',
    referredByPlaceholder: 'למשל: דרך מוטי ארגמן',
    stage: 'שלב',
    advance: 'קידום שלב',
    advanceTo: 'קידום ל',
    convert: 'הפיכה ללקוח',
    markLost: 'סימון כאבוד',
    import: 'ייבוא לידים',
    ownerBadge: 'בעלים',

    // ── מעקב אחרי ליד ──────────────────────────────────────────────────────────────
    // חזרה לליד היא לא משימה: משימה היא משהו להפיק, וחזרה לליד היא מעקב קשר. לכן
    // התאריך יושב על הליד עצמו, ולא ברשימת המשימות שלידו.
    followUp: 'לחזור אליהם ב',
    followUpNone: 'לא נקבע מועד חזרה',
    followUpDue: 'לחזור אליהם היום',
    followUpLate: 'חזרה באיחור',
    followUpNext: 'חזרה',

    // ההערה הכללית — שדה אחד שמתעדכן, ולא היסטוריה. קיים בעמודה clients.notes מאז
    // מיגרציה 002 ועד עכשיו לא היה לו שדה במסך הלידים.
    generalNotes: 'מידע כללי על הליד',
    generalNotesPlaceholder: 'למשל: עמותה בבני ברק, שני סניפים, מתעניינים בקמפיין לקראת פסח.',

    // ── היסטוריית הקשר ─────────────────────────────────────────────────────────────
    // שורה אחת לכל שיחה, נצברת. לא נמחקת ולא נדרסת — מה שנאמר ביום מסוים הוא מה שנאמר.
    contactLog: 'היסטוריית קשר',
    contactLogAdd: '＋ תיעוד שיחה',
    contactLogEmpty: 'עדיין לא תועדה שיחה עם הליד הזה.',
    contactDate: 'תאריך השיחה',
    contactBody: 'מה נאמר / מה הוסכם',
    contactBodyPlaceholder: 'למשל: דיברתי עם דוד, מבקש הצעה לשלושה חודשים. חוזר אליי אחרי החג.',
    contactSave: 'שמירת התיעוד',
    contactBy: 'תועד על ידי',
    contactDeleteTitle: 'מחיקת תיעוד שיחה',
    contactDeleteQuestion: 'למחוק את התיעוד לצמיתות?',
    contactDeleteScope: 'יימחק התיעוד הזה בלבד. שאר היסטוריית הקשר, הליד והמשימות שלו לא מושפעים.',
    // In the delete-a-client / delete-leads dialogs, which always NAME what goes.
    deleteNotes: 'תיעודי שיחות',
    // Which field the server insists on before a stage advance (mirrors STAGE_GATES).
    needContact: 'כדי לקדם ליד ל"נוצר קשר" יש למלא טלפון, דוא"ל או מקור הפניה.',
    needOwner: 'כדי לקדם את הליד יש לבחור בעלים.',
    // The convert dialog spells out the consequences instead of asking "בטוח?" —
    // this is the step that moves the row to another screen and opens billing.
    convertPoints: [
      'הוא ייצא ממסך הלידים ויעבור ללוח המשימות.',
      'מרגע זה אפשר לפתוח לו עבודות ולרשום לו חשבוניות.',
      'תיפתח משימת המשך אצל הבעלים של הליד.',
    ],
    convertedTitle: 'הליד הפך ללקוח',
    convertedBody: 'הלקוח עבר ללוח המשימות, עם משימת ההמשך שנפתחה לו.',
    toBoard: 'מעבר ללוח המשימות',
    lostBody: 'הליד יצא ממסך הלידים; המשימות וההיסטוריה שלו נשמרות. אין דרך להחזיר ליד אבוד מהממשק.',
    // Bulk delete. "בחירת הכול" means every lead CURRENTLY ON SCREEN — after the
    // filters, not the whole pipeline — so the label names the number it will select
    // and the count beside it is what actually gets deleted.
    select: 'בחירה',
    selectAll: (n) => `בחירת הכול (${n})`,
    clearSelection: 'ניקוי הבחירה',
    selectedCount: (n) => (n === 1 ? 'ליד אחד נבחר' : `${n} לידים נבחרו`),
    deleteSelected: 'מחיקת הנבחרים',
    deleteTitle: 'מחיקת לידים',
    // Heads the dialog in place of a record name: the COUNT is what has to be read
    // before a bulk delete, and it is also what has to be typed to arm it.
    deleteCount: (n) => (n === 1 ? 'ליד אחד' : `${n} לידים`),
    deleteListHeading: 'הלידים שיימחקו:',
  },
  // How much a task needs doing today. 'נמוך' means parked by choice — the hint
  // says so, because on a shared board "someone decided this waits" is different
  // information from "this doesn't matter".
  taskUrgency: {
    urgent: 'דחוף',
    normal: 'רגיל',
    low: 'נמוך',
  },
  taskUrgencyHint: 'נמוך = הוחלט שזה ממתין, לא שזה לא חשוב.',
  urgencyFilterAll: 'הכול',
  urgencyLabel: 'דחיפות',
  leadStages: {
    new: 'חדש',
    contacted: 'נוצר קשר',
    meeting: 'פגישה',
    proposal: 'הצעת מחיר',
    negotiation: 'משא ומתן',
    active: 'לקוח פעיל',
    lost: 'אבוד',
  },
  leadImport: {
    title: 'ייבוא לידים מגיליון',
    pick: 'בחירת קובץ',
    parsing: 'קורא את הקובץ…',
    willCreate: 'לידים חדשים ייווצרו',
    alreadyImported: 'כבר קיימים (ידולגו)',
    mappingTitle: 'מיפוי עמודות',
    duplicatesTitle: 'ארגונים שמופיעים יותר מפעם אחת',
    unparsableTitle: 'שורות שלא זוהו בוודאות',
    noNextStepTitle: 'לידים ללא צעד הבא',
    ownerCol: 'בעלים שזוהה',
    nameCol: 'שם',
    contactCol: 'איש קשר',
    referredByCol: 'הופנה על ידי',
    noteCol: 'משימה (הצעד הבא)',
    include: 'לייבא',
    skip: 'לדלג',
    doImport: 'ייבוא',
    committed: 'יובאו',
    reset: 'קובץ אחר',
    empty: 'לא נמצאו שורות בקובץ.',
    unmatchedOwner: 'לא זוהה',
  },
};

export default leads;
